import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const SizeMaster = () => {
  const [SizeUser, setSizeUser] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_size"
        );

        // FIX: API returns "row" not "data"
        const apiData = response?.data?.row;

        // Always set an array to prevent map error
        setSizeUser(Array.isArray(apiData) ? apiData : []);
      } catch (error) {
        console.error("Fetch error:", error);
        setSizeUser([]); // Prevent errors
      }
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_mst_prod_size",
        { size_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === true) {
        setSizeUser((prevUser) =>
          prevUser.filter((user) => user.size_id !== userId)
        );
        toast.error(response.data.message || "Data Deleted Successfully!");
        navigate("/size-list");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Failed to delete Size.");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Size Master</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="#">Master</a>
                </li>
                <li className="breadcrumb-item active">Size Master</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Add Size Form */}
        <div className="row">
          {/* Size List */}
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h5>All Sizes</h5>
                <div className="d-flex gap-2">
                  <Link to="/size-add" className="btn btn-sm btn-blue">
                    Add Size
                  </Link>
                  <Link to="#" className="btn btn-sm btn-success">
                    Export
                  </Link>
                </div>
              </div>

              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-bordered table-hover mb-0">
                    <thead className="bg-light">
                      <tr>
                        <th>Sr No</th>
                        <th>Size Label</th>
                        <th>Size Name</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {SizeUser.map((size, index) => (
                        <tr key={size.size_id}>
                          <td>{index + 1}</td>
                          <td>{size.size_label}</td>
                          <td>{size.size_name}</td>
                          <td>
                            <span
                              className={`badge ${
                                size.status === "Active"
                                  ? "bg-success-subtle text-success"
                                  : "bg-danger-subtle text-danger"
                              }`}
                            >
                              {size.status}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex gap-2">
                              <Link
                                to={`/size-edit/${size.size_id}`}
                                className="btn btn-soft-primary btn-sm"
                              >
                                <i className="fa-solid fa-pencil fs-16"></i>
                              </Link>
                              <span
                                onClick={() => deleteUser(size.size_id)}
                                className="btn btn-soft-danger btn-sm"
                              >
                                <i className="fa-solid fa-trash fs-16"></i>
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}

                      {SizeUser.length === 0 && (
                        <tr>
                          <td colSpan="5" className="text-center text-muted">
                            No sizes available
                          </td>
                        </tr>
                      )}
                    </tbody>

                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer mt-5">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 text-center">
                © Venton. Crafted by{" "}
                <iconify-icon
                  icon="iconamoon:heart-duotone"
                  className="fs-18 text-danger"
                />{" "}
                <a href="#" className="fw-bold footer-text" target="_blank">
                  Techzaa
                </a>
              </div>
            </div>
          </div>
        </footer>

      </div>
    </div>
  );
};

export default SizeMaster;
